// RecordCard.jsx with image display and optional image update for existing records

import React, { useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios';

const RecordCard = ({ data, textOnly = false, refreshNewArrivals }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [title, setTitle] = useState(data.Title);
  const [artist, setArtist] = useState(data.Artist);
  const [format, setFormat] = useState(data.Format);
  const [image, setImage] = useState(data.Image);
  const [status, setStatus] = useState('');
  const CLOUD_NAME = 'dnybxda3y';
  const UPLOAD_PRESET = 'concert_photos';

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleDelete = async () => {
    try {
      await axios.delete(`/api/delete-new-arrival/${data._id}`);
      setStatus('✅ Deleted');
      refreshNewArrivals();
      closeModal();
    } catch (err) {
      console.error(err);
      setStatus('❌ Failed to delete');
    }
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`/api/update-new-arrival/${data._id}`, {
        Title: title,
        Artist: artist,
        Format: format,
        Image: image
      });
      setStatus('✅ Updated');
      setEditMode(false);
      refreshNewArrivals();
    } catch (err) {
      console.error(err);
      setStatus('❌ Update failed');
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
  
    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await res.json();
      const transformedURL = data.secure_url.replace('/upload/', '/upload/w_500,c_fit,q_auto,f_auto/');
  
      setImage(transformedURL);
    } catch (err) {
      console.error('Cloudinary Upload Error:', err);
    }
  };

  useEffect(() => {
    setTitle(data.Title);
    setArtist(data.Artist);
    setFormat(data.Format);
    setImage(data.Image);
  }, [data]);  

  return (
    <>
      <div className={`record-card${textOnly ? ' text-only' : ''}`} onClick={openModal} style={{ cursor: 'pointer' }}>
        {data.Image && <img src={data.Image} alt={data.Title} style={{ width: '100%', maxHeight: '150px', objectFit: 'cover' }} />}
        <p>
          <strong>{data.Artist}</strong><br />
          {data.Title}<br />
          <em>{data.Format}</em>
        </p>
      </div>

      {isOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>

            <button className="close-button" onClick={closeModal}>×</button>

            <div className="modal-flex-container">

              {/* Left Side: Info and Controls */}
              <div className="modal-info">
                {editMode ? (
                  <>
                    <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" /><br />
                    <input value={artist} onChange={(e) => setArtist(e.target.value)} placeholder="Artist" /><br />
                    <input value={format} onChange={(e) => setFormat(e.target.value)} placeholder="Format" /><br />
                    <input type="file" accept="image/*" onChange={handleImageChange} /><br />
                    {image && <img src={image} alt="Preview" className="modal-image-preview" />}<br />
                    <button onClick={handleUpdate}>Save</button>
                  </>
                ) : (
                  <>
                    <h2>{data.Title}</h2>
                    <h3>{data.Artist}</h3>
                    <p><strong>Format:</strong> {data.Format}</p>
                  </>
                )}

                {localStorage.getItem('isAdmin') === 'true' && (
                  <div style={{ marginTop: '10px' }}>
                    {editMode ? (
                      <button onClick={() => setEditMode(false)}>Cancel</button>
                    ) : (
                      <>
                        <button onClick={() => setEditMode(true)}>Edit</button>
                        <button onClick={handleDelete} style={{ marginLeft: '10px', color: 'red' }}>Delete</button>
                      </>
                    )}
                    <div style={{ marginTop: '5px' }}>{status}</div>
                  </div>
                )}
              </div>

              {/* Right Side: Large Image */}
              <div className="modal-image-container">
                {!editMode && data.Image && (
                  <img src={data.Image} alt={data.Title} className="modal-image-large" />
                )}
              </div>

            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default RecordCard;
